import { IAgentSchema, IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { AGENCY_LABEL, isAgency, MANAGEMENT_COMPANY_LABEL, RENT_DEPARTMENT_LABEL } from './agent';
import { isFakeSubAgent } from './isFakeSubAgent';
import { isManagementCompany } from './isManagementCompany';
import { isRentDepartment } from './isRentDepartment';

export function getAgentBrand(agent: IAgentSchema | null, offer: IOfferSchema): string | undefined {
  if (!agent) {
    return undefined;
  }

  if (isManagementCompany(agent)) {
    return MANAGEMENT_COMPANY_LABEL;
  }

  if (isRentDepartment(agent)) {
    return RENT_DEPARTMENT_LABEL;
  }

  if ((isAgency(agent) || agent.isSubAgent) && !agent.isDeveloper) {
    return AGENCY_LABEL;
  }

  if (isFakeSubAgent(agent, offer) && agent.companyName) {
    return agent.companyName;
  }

  return undefined;
}
